import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Header from "../../Common/Layout/Header";
import jsonData from "../../VisaData/b2bvisas.json";
import styles from "./Search.module.css";
import config from "../../Common/Configurations/APIConfig";
import moment from "moment";
import VisaTabs from "../AllTabs/VisaTabs";
import { useAuth } from "../../Common/Configurations/AuthContext";
import apiService from "../../Common/Configurations/APIService";
import ModalVisaApplicantForm from "../Visas/VisaApplicantForm";
import VisaOffers from "../Advertisements/VisaOffers";
import VisaSidebarOffers from "../Advertisements/VisaSidebarOffers";

export default function SearchVisas() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const today = new Date();
  const futureDate = new Date(today);
  const [inputValue, setInputValue] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [visas, setVisas] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [terms, setTerms] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [loadingStates, setLoadingStates] = useState({});
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [activeTab, setActiveTab] = useState("visas");
  const [btnLoading, setBtnLoading] = useState(false);
  const [selectedVisa, setSelectedVisa] = useState(null);
  const [showVisaModal, setShowVisaModal] = useState(false);
  const [shareLoading, setShareLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);

  // New states for supplier modal
  const [suppliers, setSuppliers] = useState([]);
  const [supplierSearch, setSupplierSearch] = useState("");
  const [showSupplierModal, setShowSupplierModal] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);

  // New states for visa applicant form
  const [showApplicantForm, setShowApplicantForm] = useState(false);
  const [createdVisaRequest, setCreatedVisaRequest] = useState(null);
  const [applicantsList, setApplicantsList] = useState([]);

  // State to track if search has been performed
  const [hasSearched, setHasSearched] = useState(false);

  // New state for confirmation modal
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [pendingSupplierAction, setPendingSupplierAction] = useState(null);

  const handleReset = () => {
    setInputValue("");
    setFilteredSuggestions([]);
    setIsDropdownVisible(false);
    setSelectedCountry(null);
    setVisas([]);
    setDocuments([]);
    setTerms([]);
    setFaqs([]);
    setLoadingStates({});
    setSearchLoading(false);
    setSelectedVisa(null);
    setShowVisaModal(false);
    setShareLoading(false);
    setModalLoading(false);
    setShowSupplierModal(false);
    setSupplierSearch("");
    setSelectedSupplier(null);
    setShowApplicantForm(false);
    setCreatedVisaRequest(null);
    setApplicantsList([]);
    setHasSearched(false); // Reset search state
    setShowConfirmationModal(false);
    setPendingSupplierAction(null);
  };

  const handleInputChange = (e) => {
    const query = e.target.value;
    setInputValue(query);

    if (query.length > 0) {
      setSearchLoading(true);
      const filtered = jsonData.filter((item) =>
        item.name.toLowerCase().includes(query.toLowerCase())
      );
      setTimeout(() => {
        setFilteredSuggestions(filtered);
        setIsDropdownVisible(true);
        setSearchLoading(false);
      }, 300);
    } else {
      setFilteredSuggestions([]);
      setIsDropdownVisible(false);
      setSearchLoading(false);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setInputValue(suggestion.name);
    setSelectedCountry(suggestion.name);
    setIsDropdownVisible(false);
    setSearchLoading(true);
    setHasSearched(true); // Set that search has been performed

    setTimeout(() => {
      console.log(suggestion);
      if (suggestion.visas !== null) {
        setVisas(suggestion.visas);

        const initialLoadingStates = {};
        suggestion.visas.forEach((visa, index) => {
          initialLoadingStates[index] = false;
        });
        setLoadingStates(initialLoadingStates);
      }
      if (suggestion.visaDocuments !== null) {
        setDocuments(suggestion.visaDocuments);
      }
      if (suggestion.visaTerms !== null) {
        setTerms(suggestion.visaTerms);
      }
      if (suggestion.visaFAQs !== null) {
        setFaqs(suggestion.visaFAQs);
      }
      setSearchLoading(false);
    }, 500);
  };

  const handleViewVisa = (visa) => {
    setSelectedVisa(visa);
    setShowVisaModal(true);
    setModalLoading(false);
  };

  // Function to fetch applicants for a visa request
  const GetApplicants = async (visaRequestId) => {
    try {
      // Use hardcoded endpoint to avoid undefined error
      const url = `${config.GETVISAAPPLICANTSBYREQUEST}/${createdVisaRequest.visaRequestId}`;

      console.log("Fetching applicants from:", url);

      const res = await apiService.getAll(url);
      setApplicantsList(res || []);
    } catch (error) {
      console.error("Error fetching applicants:", error);
      setApplicantsList([]);
    }
  };

  const handleSubmit = async (
    e,
    visa,
    index,
    isFromModal = false,
    supplierId = null
  ) => {
    e.preventDefault();

    if (isFromModal) {
      setModalLoading(true);
    } else {
      setLoadingStates((prev) => ({
        ...prev,
        [index]: true,
      }));
    }

    const formData = {
      visaRequestId: "00000000-0000-0000-0000-000000000000",
      visaId: visa.visaId,
      leadSource: "B2B",
      visaName: visa.visaName,
      countryName: visa.visaCountryName,
      travelDate: moment(new Date()).format("YYYY-MM-DD"),
      expectedDate: moment(
        futureDate.setDate(
          today.getDate() + parseInt(visa?.processingTime + 1, 10)
        )
      ).format("YYYY-MM-DD"),
      noOfApplicants: 0,
      userId: user.id,
      email: user.email,
      mobile: user.phoneNumber,
      visaRequestStatus: "NEW",
      paymentStatus: "PENDING",
      supplierId: supplierId || "00000000-0000-0000-0000-000000000000",
    };

    try {
      const res = await apiService.post(config.CREATEVISAREQUEST, formData);

      if (supplierId) {
        // If supplier is selected, store the created request and open applicant form
        setCreatedVisaRequest(res);
        setShowSupplierModal(false);
        setShowApplicantForm(true);
        // Fetch existing applicants if any
        setTimeout(() => {
          GetApplicants(res.visaRequestId);
        }, 100);
      } else {
        navigate("/visarequest/" + res.visaRequestId);
      }
    } catch (error) {
      console.error("Error creating visa request:", error);
    } finally {
      if (isFromModal) {
        setModalLoading(false);
      } else {
        setLoadingStates((prev) => ({
          ...prev,
          [index]: false,
        }));
      }
    }
  };

  // Function to format price display with colors
  const formatPrice = (visa) => {
    if (visa.adultPrice && visa.childPrice) {
      return (
        <div className="d-flex flex-column">
          <span className="fw-bold text-success">
            Adult: INR{visa.adultPrice}
          </span>
          <span className="fw-bold text-primary">
            Child: INR{visa.childPrice}
          </span>
        </div>
      );
    } else if (visa.adultPrice) {
      return <span className="fw-bold text-success">₹{visa.adultPrice}</span>;
    } else if (visa.childPrice) {
      return <span className="fw-bold text-primary">₹{visa.childPrice}</span>;
    } else {
      return <span className="text-warning fw-bold">Contact for price</span>;
    }
  };

  const shareViaWhatsApp = async (visa) => {
    setShareLoading(true);

    await new Promise((resolve) => setTimeout(resolve, 500));

    const websiteUrl = "https://www.visaproservices.com";
    const priceInfo =
      visa.adultPrice && visa.childPrice
        ? `• *Adult Price:* INR${visa.adultPrice}\n• *Child Price:* INR${visa.childPrice}`
        : visa.adultPrice
        ? `• *Price:* INR${visa.adultPrice}`
        : visa.childPrice
        ? `• *Price:* INR${visa.childPrice}`
        : "• *Price:* Contact for details";

    const message = `🏢 *${user.brandName}*

🌟 *Visa Information for ${selectedCountry}* 🌟

📋 *Visa Details:*
• *Visa Name:* ${visa.visaName}
• *Type:* ${visa.visaType}
• *Entry:* ${visa.entry}
• *Stay Period:* ${visa.stayPeriod}
• *Validity:* ${visa.validity}

💰 *Pricing (INR):*
${priceInfo}

📄 *Required Documents:*
${documents.map((doc, index) => `• ${doc.documentName}`).join("\n")}

🌐 *Apply Now:* ${websiteUrl}/apply?country=${encodeURIComponent(
      selectedCountry
    )}&visa=${encodeURIComponent(visa.visaName)}

💬 *Thank you for your interest in ${user.brandName}!*
We're here to assist you with your visa application process. Feel free to contact us for any queries or assistance.

👤 *Contact Details:*
• *Name:* ${user.name}
• *Email:* ${user.email}
• *Phone:* ${user.phoneNumber}

*Note:* Terms and conditions apply.`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://web.whatsapp.com/send?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");

    setShareLoading(false);
  };

  // Supplier related functions
  useEffect(() => {
    if (showSupplierModal && selectedVisa) {
      GetSuppliers("");
    }
  }, [showSupplierModal, selectedVisa]);

  const handleOpenSupplierModal = (visa) => {
    if (visa && visa.visaId) {
      setSelectedVisa(visa);
      setShowSupplierModal(true);
      setSupplierSearch("");
    } else {
      console.error("Invalid visa object passed to handleOpenSupplierModal");
    }
  };

  const handleCloseSupplierModal = () => {
    setShowSupplierModal(false);
    setSupplierSearch("");
    setSelectedSupplier(null);
  };

  const GetSuppliers = async (searchQuery) => {
    if (!selectedVisa) return;

    try {
      let url = `${config.GETSUPPLIERVISAPRICESBYVISAID}/${selectedVisa.visaId}`;
      if (searchQuery) {
        url += `?search=${encodeURIComponent(searchQuery)}`;
      }

      const res = await apiService.getAll(url);
      setSuppliers(res);
    } catch (error) {
      console.error("Error fetching supplier visa prices:", error);
      setSuppliers([]);
    }
  };

  // Updated function to show confirmation modal
  const handleSupplierSelection = (supplier, index) => {
    setPendingSupplierAction({ supplier, index });
    setShowConfirmationModal(true);
  };

  // Function to handle confirmed application
  const handleConfirmedApplication = () => {
    if (pendingSupplierAction) {
      const { supplier, index } = pendingSupplierAction;
      setSelectedSupplier(supplier);
      // Create a synthetic event for the handleSubmit function
      const syntheticEvent = { preventDefault: () => {} };
      handleSubmit(
        syntheticEvent,
        selectedVisa,
        index,
        false,
        supplier.supplierId
      );
    }
    setShowConfirmationModal(false);
    setPendingSupplierAction(null);
  };

  // Function to cancel the application
  const handleCancelApplication = () => {
    setShowConfirmationModal(false);
    setPendingSupplierAction(null);
  };

  // Handle applicant form success
  const handleApplicantFormSuccess = () => {
    // Refresh applicants list
    if (createdVisaRequest) {
      GetApplicants(createdVisaRequest.visaRequestId);
    }
  };

  // Handle applicant form close
  const handleApplicantFormClose = () => {
    setShowApplicantForm(false);
    // Optionally navigate to visa request page after adding applicants
    if (createdVisaRequest) {
      navigate("/visarequest/" + createdVisaRequest.visaRequestId);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }

  return (
    <div id="layout-wrapper">
      <Header></Header>
      <div class="vertical-overlay"></div>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row" id="contactList">
              <div className="col-lg-12">
                <div className="card">
                  <div className="p-2">
                    <VisaTabs pageName="VISASEARCH" />{" "}
                  </div>
                  <div className="card-header d-flex align-items-center border-0">
                    <h5 className="card-title mb-0 flex-grow-1">
                      SEARCH & APPLY VISAS
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row g-2 align-items-center">
                      <div className="col-xl-4 col-md-6">
                        <div className="search-box">
                          <input
                            type="text"
                            value={inputValue}
                            onChange={handleInputChange}
                            placeholder="Enter country Name..."
                            className="form-control"
                          />
                        </div>
                        {isDropdownVisible && (
                          <ul className={styles.suggestionsList}>
                            {filteredSuggestions.map((suggestion) => (
                              <li
                                key={suggestion.visaUrl}
                                className={styles.suggestionItem}
                                onClick={() =>
                                  handleSuggestionClick(suggestion)
                                }
                              >
                                <span className={styles.flag}>
                                  <img
                                    src={`https://flagcdn.com/w40/${suggestion.flagSrc.toLowerCase()}.png`}
                                    alt={suggestion.name}
                                    className={styles.flagImage}
                                  />
                                </span>
                                {suggestion.name}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>

                      <div className="col-auto">
                        <button
                          className="btn btn-danger"
                          onClick={handleReset}
                        >
                          <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Only show table and lists if search has been performed */}
                {hasSearched && (
                  <div className="row">
                    <div className="col-lg-3">
                      <div className="card">
                        <div className="card-body">
                          <div className="sticky-top" style={{ top: "20px" }}>
                            <VisaSidebarOffers />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Search Results - 9 columns */}
                    <div className="col-lg-9">
                      <div className="card">
                        <div className="card-body">
                          <div className="table-responsive table-card">
                            <table
                              className="table align-middle table-nowrap"
                              id="customerTable"
                            >
                              <thead className="table-light text-muted">
                                <tr>
                                  <th>SNo</th>
                                  <th>Visa Details</th>
                                  <th>Validity</th>
                                  <th>Price (INR)</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody className="list form-check-all">
                                {searchLoading ? (
                                  <tr>
                                    <td
                                      colSpan="5"
                                      className="text-center py-3"
                                    >
                                      <div
                                        className="spinner-border text-primary"
                                        role="status"
                                      >
                                        <span className="visually-hidden">
                                          Loading...
                                        </span>
                                      </div>
                                    </td>
                                  </tr>
                                ) : visas.length > 0 ? (
                                  visas.map((v, index) => (
                                    <tr key={index}>
                                      <td className="sno">{index + 1}</td>
                                      <td>
                                        <div className="d-flex flex-column">
                                          <span className="fw-semibold">
                                            {v.visaName}
                                          </span>
                                          <div className="d-flex flex-wrap gap-2 mt-1">
                                            <span className="badge bg-primary text-white">
                                              {v.visaType}
                                            </span>
                                            <span className="badge bg-success text-white">
                                              {v.entry}
                                            </span>
                                            <span className="badge bg-info text-white">
                                              {v.stayPeriod}
                                            </span>
                                          </div>
                                        </div>
                                      </td>
                                      <td className="validity">{v.validity}</td>
                                      <td className="price">
                                        {formatPrice(v)}
                                      </td>
                                      <td className="status">
                                        <button
                                          className="btn btn-sm btn-primary edit-item-btn me-2"
                                          onClick={() => handleViewVisa(v)}
                                          title="View Visa Details"
                                          disabled={loadingStates[index]}
                                        >
                                          <i className="ri-eye-line me-1"></i>{" "}
                                          View
                                        </button>
                                        <button
                                          className="btn btn-sm btn-success edit-item-btn"
                                          onClick={() =>
                                            handleOpenSupplierModal(v)
                                          }
                                          disabled={loadingStates[index]}
                                        >
                                          SHOW PRICE
                                        </button>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="5"
                                      className="text-center py-4"
                                    >
                                      <div className="text-muted">
                                        <i className="ri-search-line display-4"></i>
                                        <p className="mt-2">
                                          No visas found for the selected
                                          country
                                        </p>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>

                          {/* Documents, Terms, and FAQs sections */}
                          {visas.length > 0 && (
                            <>
                              <div className="mb-3">
                                <div className="list-group nested-list nested-sortable">
                                  <div className="list-group-item nested-1">
                                    Documents
                                    <div className="list-group nested-list nested-sortable">
                                      {documents.length > 0 &&
                                        documents.map((d, index) => (
                                          <div
                                            key={index}
                                            className="list-group-item nested-2"
                                          >
                                            {index + 1}. {d.documentName}
                                          </div>
                                        ))}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="mb-3">
                                <div className="list-group nested-list nested-sortable">
                                  <div className="list-group-item nested-1">
                                    Terms and Conditions
                                    <div className="list-group nested-list nested-sortable">
                                      {terms.length > 0 &&
                                        terms.map((d, index) => (
                                          <div
                                            key={index}
                                            className="list-group-item nested-2"
                                          >
                                            {index + 1}. {d.termsandConditions}
                                          </div>
                                        ))}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="mb-3">
                                <div className="list-group nested-list nested-sortable">
                                  <div className="list-group-item nested-1">
                                    Frequently Asked Questions
                                    <div className="list-group nested-list nested-sortable">
                                      {faqs.length > 0 &&
                                        faqs.map((d, index) => (
                                          <div
                                            key={index}
                                            className="list-group-item nested-2"
                                          >
                                            {d.question}
                                            <div className="list-group-item nested-3">
                                              {d.answer}
                                            </div>
                                          </div>
                                        ))}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {!hasSearched && <VisaOffers />}
            </div>
          </div>
        </div>
      </div>

      {/* Visa Details Modal - Updated */}
      {showVisaModal && selectedVisa && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Visa Details - {selectedVisa.visaName}
                </h5>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="row">
                    <div className="row">
                      <div className="col-md-12 mb-3">
                        <h6>Visa Information</h6>
                        <div className="row">
                          <div className="col-md-4 mb-2">
                            <div className="d-flex justify-content-between border p-2 rounded">
                              <span className="fw-bold">Visa Type:</span>
                              <span>{selectedVisa.visaType}</span>
                            </div>
                          </div>
                          <div className="col-md-4 mb-2">
                            <div className="d-flex justify-content-between border p-2 rounded">
                              <span className="fw-bold">Entry Type:</span>
                              <span>{selectedVisa.entry}</span>
                            </div>
                          </div>
                          <div className="col-md-4 mb-2">
                            <div className="d-flex justify-content-between border p-2 rounded">
                              <span className="fw-bold">Stay Period:</span>
                              <span>{selectedVisa.stayPeriod}</span>
                            </div>
                          </div>
                          <div className="col-md-4 mb-2">
                            <div className="d-flex justify-content-between border p-2 rounded">
                              <span className="fw-bold">Validity:</span>
                              <span>{selectedVisa.validity}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-2">
                  <h6>Required Documents</h6>
                  <div className="list-group">
                    {documents.length > 0 ? (
                      documents.map((doc, index) => (
                        <div key={index} className="list-group-item">
                          {index + 1}. {doc.documentName}
                        </div>
                      ))
                    ) : (
                      <div className="list-group-item text-muted">
                        No documents required
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setShowVisaModal(false)}
                  disabled={shareLoading}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary text-white"
                  onClick={() => shareViaWhatsApp(selectedVisa)}
                  disabled={shareLoading}
                >
                  {shareLoading ? (
                    <>
                      <div
                        className="spinner-border spinner-border-sm me-1"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      SHARING...
                    </>
                  ) : (
                    <>
                      <i className="ri-whatsapp-line me-1"></i> Share
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Supplier Modal */}
      {showSupplierModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-md" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <div>
                  <h5 className="modal-title mb-1">
                    Send to Supplier - {selectedCountry}
                  </h5>
                  {selectedVisa?.visaName && (
                    <div className="fw-bold text-primary fs-6">
                      {selectedVisa.visaName}
                    </div>
                  )}
                </div>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseSupplierModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Search Suppliers</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Type supplier name..."
                    value={supplierSearch}
                    onChange={(e) => {
                      setSupplierSearch(e.target.value);
                      GetSuppliers(e.target.value);
                    }}
                  />
                </div>

                <div
                  className="table-responsive"
                  style={{ maxHeight: "300px", overflowY: "auto" }}
                >
                  <table className="table table-hover align-middle">
                    <thead
                      style={{
                        position: "sticky",
                        top: 0,
                        background: "white",
                        zIndex: 1,
                      }}
                    >
                      <tr>
                        <th>Supplier</th>
                        <th>Contact</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {suppliers && suppliers.length > 0 ? (
                        suppliers.map((item, index) => (
                          <tr key={item.supplierVisaPriceId}>
                            <td>
                              <div className="fw-bold fs-6 text-primary">
                                {item.supplier?.supplierName}
                              </div>
                              <div className="text-muted small">
                                {item.visaName}
                              </div>
                              <div className="mt-1">
                                <span className="badge bg-success me-2">
                                  Adult: {item.adultPrice}
                                </span>
                                <span className="badge bg-info">
                                  Child: {item.childPrice}
                                </span>
                              </div>
                            </td>
                            <td>
                              <div className="d-flex align-items-center mb-1">
                                <i className="ri-phone-line text-success me-2"></i>
                                {item.supplier?.phoneNumber}
                              </div>
                              <div className="d-flex align-items-center">
                                <i className="ri-mail-line text-danger me-2"></i>
                                {item.supplier?.email}
                              </div>
                            </td>
                            <td>
                              <button
                                className="btn btn-sm btn-success"
                                onClick={() =>
                                  handleSupplierSelection(item, index)
                                }
                              >
                                Apply
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center py-3">
                            No suppliers found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleCloseSupplierModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Modal */}
      {showConfirmationModal && pendingSupplierAction && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-warning">
                  <i className="ri-alert-line me-2"></i>
                  Confirm Application
                </h5>
              </div>
              <div className="modal-body">
                <div className="text-center mb-3">
                  <i className="ri-question-line display-4 text-warning"></i>
                </div>
                <p className="text-center mb-3">
                  Are you sure you want to apply for this visa with{" "}
                  <strong>
                    {pendingSupplierAction.supplier.supplier?.supplierName}
                  </strong>
                  ?
                </p>
                <div className="alert alert-info">
                  <div className="d-flex flex-column">
                    <span>
                      <strong>Visa:</strong> {selectedVisa?.visaName}
                    </span>
                    <span>
                      <strong>Country:</strong> {selectedCountry}
                    </span>
                    <span>
                      <strong>Supplier:</strong>{" "}
                      {pendingSupplierAction.supplier.supplier?.supplierName}
                    </span>
                    <div className="mt-2">
                      <span className="badge bg-success me-2">
                        Adult Price: ₹
                        {pendingSupplierAction.supplier.adultPrice}
                      </span>
                      <span className="badge bg-info">
                        Child Price: ₹
                        {pendingSupplierAction.supplier.childPrice}
                      </span>
                    </div>
                  </div>
                </div>
                <p className="text-muted small text-center">
                  After confirmation, you will be redirected to add applicant
                  details.
                </p>
              </div>
              <div className="modal-footer justify-content-end">
                <button
                  type="button"
                  className="btn btn-danger me-3"
                  onClick={handleCancelApplication}
                >
                  <i className="ri-close-line me-1"></i> Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={handleConfirmedApplication}
                >
                  <i className="ri-check-line me-1"></i> Confirm & Apply
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Visa Applicant Form Modal */}
      {showApplicantForm && createdVisaRequest && (
        <ModalVisaApplicantForm
          show={showApplicantForm}
          onHide={handleApplicantFormClose}
          visaRequestId={createdVisaRequest.visaRequestId}
          onSuccess={handleApplicantFormSuccess}
          applicantsList={applicantsList}
        />
      )}
    </div>
  );
}
